import MainLayout from '@/components/app/layout/MainLayout';
import PageViewTracker from '@/components/app/pageViewTracker/PageViewTracker';
import BuyerForm from '@/components/buyerQualification/buyerForm/BuyerForm';
import { useCurrentAgent } from '@/hooks/agents/useCurrentAgent';
import { PAGE_VIEW_TITLE } from '@/utils/gtm';
import { getLocalesFromStaticProps } from '@/utils/locales';

const BuyerPage = () => {
  const currentAgent = useCurrentAgent();

  return (
    <MainLayout title="newBuyerProject" showSidebar={false}>
      <PageViewTracker title={PAGE_VIEW_TITLE.QUALIFICATION_BUYER_EMPTY} />
      <BuyerForm
        id={PAGE_VIEW_TITLE.QUALIFICATION_BUYER_EMPTY}
        activeAgent={currentAgent?.id.toString()}
      />
    </MainLayout>
  );
};

export const getStaticProps = getLocalesFromStaticProps;

export default BuyerPage;
